module.exports = __webpack_public_path__ + "static/shoe-sole-be1d09cf48756941b5a12482ae52736f.jpg";